<template v-if="editedScouting">
  <v-dialog v-model="dialog" max-width="1600px">
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Scouting Summary</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <ScoutingSummary :editedScouting="editedScouting" />
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closeDialog">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="editScouting">Edit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ScoutingSummary from "./ScoutingSummary.vue";

export default {
  components: {
    ScoutingSummary
  },
  data() {
    return {
      dialog: false,
      scouting: null
    };
  },
  computed: {
    editedScouting() {
      return this.scouting ? this.scouting : null;
    }
  },
  methods: {
    showDialog(scouting) {
      this.scouting = scouting;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    editScouting() {
      this.$emit('editScouting', this.scouting);
      this.closeDialog();
    }
  }
};
</script>

<style scoped>

</style>
